@if (visibility) {
  <div [ngClass]="{ 'filter-popover': isPopover }">
    @if (showSidePanel) {
      <div class="side-panel h-100">
        <div
          class="left-panel m-auto"
          (click)="setToday()"
          [ngClass]="{ selected: selectedOption === 'today' }"
          (keydown)="$event.preventDefault()"
          >
          <input
            class="mt-2 ms-2 me-2"
            type="radio"
            name="timePriod"
            [checked]="selectedOption === 'today'"
            />
            Hoy
          </div>
          <div
            class="left-panel m-auto"
            (click)="setThisWeek()"
            [ngClass]="{ selected: selectedOption === 'thisWeek' }"
            (keydown)="$event.preventDefault()"
            >
            <input
              class="mt-2 ms-2 me-2"
              type="radio"
              name="timePriod"
              [checked]="selectedOption === 'thisWeek'"
              />
              Semana
            </div>
            <div
              class="left-panel m-auto"
              (click)="setThisMonth()"
              [ngClass]="{ selected: selectedOption === 'thisMonth' }"
              (keydown)="$event.preventDefault()"
              >
              <input
                class="mt-2 ms-2 me-2"
                type="radio"
                name="timePriod"
                [checked]="selectedOption === 'thisMonth'"
                />
                Mes
              </div>
              <div
                class="left-panel last-option m-auto"
                (click)="setThisYear()"
                [ngClass]="{ selected: selectedOption === 'thisYear' }"
                (keydown)="$event.preventDefault()"
                >
                <input
                  class="mt-2 ms-2 me-2"
                  type="radio"
                  name="timePriod"
                  [checked]="selectedOption === 'thisYear'"
                  />
                  Año
                </div>
              </div>
            }
            <div class="row ps-2">
              <mat-form-field
                class="dates-select px-0 mt-1 w-100"
                appearance="outline"
                (click)="picker.open()"
                onkeypress="picker.open()"
                >
                <mat-label>Seleccione fechas</mat-label>
                <mat-date-range-input
                  [formGroup]="dateForm"
                  [rangePicker]="picker"
                  class="pt-1"
                  >
                  <input
                    matStartDate
                    placeholder="Fecha inicial"
                    formControlName="fromDate"
                    />
                    <input
                      matEndDate
                      placeholder="Fecha final"
                      formControlName="toDate"
                      (dateChange)="autoApplyFn()"
                      />
                    </mat-date-range-input>
                    @if (showSidePanel) {
                      <mat-hint>DD/MM/YYYY – DD/MM/YYYY</mat-hint>
                    }
                    <mat-datepicker-toggle matSuffix [for]="picker">
                      <mat-icon matDatepickerToggleIcon>calendar_today</mat-icon>
                    </mat-datepicker-toggle>
                    <mat-date-range-picker #picker></mat-date-range-picker>
                  </mat-form-field>
                  @if (showApplyBtn) {
                    <div
                      class="d-flex flex-wrap justify-content-end filter-date mt-3 mb-2 pe-3"
                      >
                      <button (click)="setDates($event)" class="filter-btn">Aplicar</button>
                    </div>
                  }
                </div>
              </div>
            }
